export default "__VITE_ASSET__14425dbe__$_?nuxt_component=async__"